import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
import { Link } from 'react-router-dom';
import { labPanels } from '../../data/site';
import { Eyebrow } from '../ui/Eyebrow';
import { useBrand } from '../../contexts/BrandContext';
export function LabsPreview() {
  const {
    brand
  } = useBrand();
  return <section className="bg-cream-light" data-id="element-71" data-mp="2hfnjsw9ngkfo">
      <div className="mx-auto max-w-shell px-6 py-20 md:px-8 md:py-28" data-id="element-72" data-mp="2helxfvn6obin">
        <div className="grid items-center gap-12 lg:grid-cols-2 lg:gap-20" data-id="element-73" data-mp="2cgsudbh6fxml">
          <img src={brand.images.labKit} alt={`A ${brand.name} at-home lab collection kit`} className="aspect-[16/10] w-full rounded-brand object-cover" data-id="element-74" data-mp="27g51ek9e16pq" />

          <div data-id="element-75" data-mp="1ygi2q681mf0d">
            <Eyebrow className="text-brick" data-id="element-76" data-mp="1yh1hxf6b6pap">Labs & testing</Eyebrow>
            <h2 className="mt-4 font-serif text-4xl leading-[1.06] text-ink md:text-[3.25rem]" data-id="element-77" data-mp="pyj02s4v7ti">
              Treatment starts with numbers, not a questionnaire.
            </h2>
            <ul className="mt-10" data-id="element-78" data-mp="3ss6k0f1qytnx">
              {labPanels.map(panel => <li key={panel.name} className="rule grid gap-2 py-5 sm:grid-cols-[auto_1fr] sm:gap-6" data-id="element-79" data-mp="2reia9p5gg2bg">
                  <span className="font-serif text-2xl text-brick" data-id="element-80" data-mp="2wctijvg3q4rk">{panel.markers}</span>
                  <div data-id="element-81" data-mp="2igy7gbry1xyq">
                    <h3 className="text-sm font-medium text-ink" data-id="element-82" data-mp="2ihhmnkq7m892">{panel.name}</h3>
                    <p className="mt-1 max-w-md text-sm leading-relaxed text-ink-soft" data-id="element-83" data-mp="2mit7lcy525ax">
                      {panel.detail}
                    </p>
                  </div>
                </li>)}
            </ul>
            <Link to="/labs" className="group mt-8 inline-flex items-center gap-2 text-sm text-ink transition-colors duration-150 ease-republic hover:text-brick" data-id="element-84" data-mp="31dzdlzx8i449">
              Collect at home or at 2,100 partner sites
              <ArrowRightIcon className="h-4 w-4 transition-transform duration-200 ease-republic group-hover:translate-x-1" data-id="element-85" data-mp="3t3lz0u6y5ytv" />
            </Link>
          </div>
        </div>
      </div>
    </section>;
}